import { render, staticRenderFns } from "./DadosCepComplemento.vue?vue&type=template&id=2fec9b86&"
import script from "./DadosCepComplemento.vue?vue&type=script&lang=ts&"
export * from "./DadosCepComplemento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
